<template>
    <div id="login-wrap">
        <header>
            <h1>
                <img src="./images/lhv2DA.png">
            </h1>
        </header>
        <main>
            <div id="loginBox">
                <div id="login">
                    <!-- 底部 -->
                    <router-link :to="{name:'details',query:{_q:strCookie}}" />
                    <!-- </div> -->
                    <!-- 登录弹出框 -->

                    <!-- 修改密码弹出框 -->
                    <!-- <index-set-pwd-window
                        v-if="isPwd"
                        :vuex-modeule-name="vuexModeuleName"
                    /> -->
                    <!-- 加入企业弹框 -->
                    <!-- <div
                        v-for="(item,index) in loginData.companys"
                        :key="item.subDomain"
                    >
                        <index-add-company-window
                            v-if="isCompany && !item.hasJoined"
                            :index="index"
                            :info="item"
                            :vuex-modeule-name="vuexModeuleName"
                        />
                    </div> -->

                    <!-- 黑色 遮盖罩罩 -->
                    <!-- <transition
                        name="fade"
                    >
                        <div
                            v-show="isPwd||isCompany"
                            class="login-cover-wrap"
                        />
                    </transition> -->
                </div>
                <index-login-window
                    v-show="isLoginWindow"
                    :vuex-modeule-name="vuexModeuleName"
                />
            </div>
        </main>
        <footer>
            <!-- <ul class="flex">
                <li>
                    帮助
                </li>
                <li>隐私</li>
                <li>条款</li>
            </ul> -->
            <p>copyright©2019牛卡福网络技术部出品</p>
        </footer>
    </div>
</template>
<script>
import indexLoginWindow from './components/indexLoginWindow'

import { setCookie, getCookie } from '@/utils/index'
export default {
    components: {
        indexLoginWindow,
    },
    data () {
        return {
            vuexModeuleName: 'loginModule',
            strCookie: '',
        }
    },
    computed: {
        isLoginWindow () {
            return this.$store.state[this.vuexModeuleName].isLoginWindow
        },
        isPwd () {
            return this.$store.state[this.vuexModeuleName].isPwd
        },
        isCompany () {
            return this.$store.state[this.vuexModeuleName].isCompany
        },
        loginData () {
            return this.$store.state[this.vuexModeuleName].loginData
        },

    },
    created () {
        let reg = /\S/
        setCookie('_q', window.location.search.split('=')[1] ? reg.test(window.location.search.split('=')[1]) ? window.location.search.split('=')[1] : null : null, window.location.host.substring(window.location.host.indexOf('.')))
        this.strCookie = getCookie('_q') ? getCookie('_q') : null
        this.$nextTick(() => {
            this.$store.commit(this.vuexModeuleName + '/updateStateData', {
                isLoginWindow: true
            })
        })
    }
}
</script>
<style lang="scss" scoped>
#login-wrap {
    overflow: auto;
    position: relative;
    width: 100%;
    height: 100%;
}
header {
    padding: 0px;
    height: 70px;
    z-index: 2;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
    img {
        padding: 17px 40px;
        width: 100px;
        height: 36px;
    }
}
main {
    max-width: 100%;
    min-width: 1260px;
    width: 100%;
    height: auto;
    background: #111a65;
}
#loginBox {
    max-width: 1200px;
    height: 720px;
    box-sizing: border-box;
    background: #111a65;
    padding: 100px 0 80px;
    margin: 0 auto;
    clear: both;
}
#login {
    background: url(./images/wps.png) left center / contain no-repeat;
    width: 550px;
    height: 100%;
    float: left;
    margin-right: 50px;
    a {
        display: block;
        width: 550px;
        height: 100%;
        cursor: pointer;
    }
}
.login-window {
    float: right;
    overflow: hidden;
}

footer {
    font-size: 14px;
    font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
        '微软雅黑', Arial, sans-serif;
    font-weight: 400;
    color: rgba(109, 114, 120, 1);
    line-height: 70px;
    p {
        background: rgba(255, 255, 255, 1);
        text-align: center;
    }
}

@media screen and (max-width: 1680px) {
    #login .login-window {
        right: 10%;
    }
}

.el-form-item .el-form-item__content {
    line-height: 0px !important;
}
</style>